 export enum RuleTabEnum {
    CriteriaType,
    RuleTemplate,
    Rule,
}
export enum RuleInputType {
     Text,
     Select,
     Checkbox,
     MultipleInput,
     CriteriaTypeInput,
     RuleTemplateInput,
    RegionInput,
    TenantInput,
    RuleCriteriaTypeInput
 }

